import { Union, Record } from "../../../fable_modules/fable-library-js.4.24.0/Types.js";
import { Provider, Product, ImageUrl_get_None, Category, Book, BookAuthor, SearchedBook_$reflection, Product_$reflection, Provider_$reflection } from "../../../Shopfoo.Domain.Types/Catalog.js";
import { class_type, string_type, union_type, record_type, tuple_type, list_type } from "../../../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { Remote$1, ApiRequestArgs$2, Cmder__ofApiRequest_Z503C4AF9, Remote$1_$reflection } from "../../../Remoting.js";
import { CatalogApi_SearchRequest$1, CatalogApi_SearchResponse$1, CatalogApi_GetProductsResponse_$reflection, CatalogApi_SearchResponse$1_$reflection } from "../../../Shopfoo.Shared/Remoting.js";
import { Translations_$reflection } from "../../../Shopfoo.Domain.Types/Translations.js";
import { ApiError_$reflection } from "../../../Shopfoo.Shared/Errors.js";
import { FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.24.0/Result.js";
import { Shopfoo_Domain_Types_Common_OLID__OLID_get_AsSKU, Shopfoo_Domain_Types_Common_ISBN__ISBN_get_AsSKU, OLID, ISBN } from "../../../Shopfoo.Domain.Types/Common.js";
import { empty, ofSeq } from "../../../fable_modules/fable-library-js.4.24.0/Set.js";
import { createObj, equals, comparePrimitives, compare } from "../../../fable_modules/fable-library-js.4.24.0/Util.js";
import { Searcher__Product, SearchResultModule_build, SearchResultModule_status, Searcher_$ctor_Z1481DE65 } from "../../../Search.js";
import { map, append as append_1, singleton, empty as empty_1, collect, delay, toList } from "../../../fable_modules/fable-library-js.4.24.0/Seq.js";
import { sortBy, empty as empty_2, ofArray, append, singleton as singleton_1, length } from "../../../fable_modules/fable-library-js.4.24.0/List.js";
import { Cmd_none, Cmd_ofEffect, Cmd_batch } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { Filters__ToBazaar_Z3BF3079, Filters__ToBooks, Filters__get_Provider } from "../../../Filters.js";
import { Env_user, Shopfoo_Client_Pages_Shared_Env_IFullContext__IFullContext_get_Translations, Env_prepareRequest, Env_fillTranslations, Env_prepareQueryWithTranslations } from "../../Shared.js";
import { Page, Page_CurrentNotFound, Router_navigatePage, Page_$reflection } from "../../../Routing.js";
import { createElement } from "react";
import React from "react";
import { Feat, $007CUserCanNotAccess$007C_$007C } from "../../../Shopfoo.Domain.Types/Security.js";
import { useEffectOnce } from "../../../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { defaultOf } from "../../../fable_modules/fable-library-js.4.24.0/Util.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.4.2.0/program.fs.js";
import { reactApi } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { TranslationPages_Home__get_Bazaar, AppTranslations__get_Home, TranslationPages_Home__get_Books } from "../../../Shopfoo.Shared/Translations.js";
import book_1 from "@iconify-icons/fa6-solid/book";
import store from "@iconify-icons/fa6-solid/store";
import { Helpers_combineClasses } from "../../../fable_modules/Feliz.DaisyUI.5.0.0/DaisyUI.fs.js";
import { apiError as apiError_2 } from "../../../Components/Alert.js";
import { ProductFilterBar } from "./FilterBar.js";
import { ProductsTable } from "./ProductsTable.js";
import { toKebab } from "../../../Shopfoo.Common/String.js";
import { interpolate, toText } from "../../../fable_modules/fable-library-js.4.24.0/String.js";
import { icon as icon_1 } from "../../../Components/Icon.js";

export class Model extends Record {
    constructor(Products, SearchedBooks) {
        super();
        this.Products = Products;
        this.SearchedBooks = SearchedBooks;
    }
}

export function Model_$reflection() {
    return record_type("Shopfoo.Client.Pages.Product.Index.Page.Model", [], Model, () => [["Products", Remote$1_$reflection(tuple_type(Provider_$reflection(), list_type(Product_$reflection())))], ["SearchedBooks", Remote$1_$reflection(CatalogApi_SearchResponse$1_$reflection(Product_$reflection()))]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ResetProvider", "SelectProvider", "ProductsFetched", "SearchBooks", "BooksSearched", "ClearSearchedBooks"];
    }
}

export function Msg_$reflection() {
    return union_type("Shopfoo.Client.Pages.Product.Index.Page.Msg", [], Msg, () => [[], [["Item", Provider_$reflection()]], [["Item1", Provider_$reflection()], ["Item2", union_type("Microsoft.FSharp.Core.FSharpResult`2", [tuple_type(CatalogApi_GetProductsResponse_$reflection(), Translations_$reflection()), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", tuple_type(CatalogApi_GetProductsResponse_$reflection(), Translations_$reflection())]], [["ErrorValue", ApiError_$reflection()]]])]], [["searchTerm", string_type]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [CatalogApi_SearchResponse$1_$reflection(SearchedBook_$reflection()), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", CatalogApi_SearchResponse$1_$reflection(SearchedBook_$reflection())]], [["ErrorValue", ApiError_$reflection()]]])]], []]);
}

const Product_fakeBook = new Book(new ISBN("0"), "", ofSeq([new BookAuthor(new OLID(""), "Fake")], {
    Compare: compare,
}), empty({
    Compare: comparePrimitives,
}));

const Product_notFound = new Product(Shopfoo_Domain_Types_Common_ISBN__ISBN_get_AsSKU(Product_fakeBook.ISBN), "❗ Fake", "Fake book to demo how the page handles a product not found", new Category(1, [Product_fakeBook]), ImageUrl_get_None());

function Cmd_loadProducts(cmder, request) {
    const provider = request.Body.Query;
    return Cmder__ofApiRequest_Z503C4AF9(cmder, new ApiRequestArgs$2((api) => api.Catalog.GetProducts(request), (err) => (new Msg(2, [provider, new FSharpResult$2(1, [err])])), (data) => (new Msg(2, [provider, new FSharpResult$2(0, [data])]))));
}

function Cmd_searchBooks(cmder, request) {
    return Cmder__ofApiRequest_Z503C4AF9(cmder, new ApiRequestArgs$2((api) => api.Catalog.SearchBooks(request), (arg) => (new Msg(4, [new FSharpResult$2(1, [arg])])), (arg_1) => (new Msg(4, [new FSharpResult$2(0, [arg_1])]))));
}

function PreviewProduct_previewSearchedBook(searchedBook) {
    const book = new Book(new ISBN(""), searchedBook.Subtitle, searchedBook.Authors, empty({
        Compare: comparePrimitives,
    }));
    return new Product(Shopfoo_Domain_Types_Common_OLID__OLID_get_AsSKU(searchedBook.EditionKey), `✨ ${searchedBook.Title}`, "", new Category(1, [book]), ImageUrl_get_None());
}

function PreviewProduct_fromSearchBooksResponse(response, searchConfig, translations) {
    const search = Searcher_$ctor_Z1481DE65(searchConfig, translations);
    const items = toList(delay(() => collect((book) => {
        const product = PreviewProduct_previewSearchedBook(book);
        const searchStatus = SearchResultModule_status(SearchResultModule_build(searchConfig, (column) => Searcher__Product(search, product, column)));
        if (searchStatus.tag === 0) {
            return empty_1();
        }
        else {
            return singleton(product);
        }
    }, response.Items)));
    return new CatalogApi_SearchResponse$1(items, response.TotalCount - (length(response.Items) - length(items)));
}

function init(filters) {
    return [new Model(new Remote$1(0, []), new Remote$1(0, [])), Cmd_batch(toList(delay(() => {
        const matchValue = Filters__get_Provider(filters);
        if (matchValue == null) {
            return empty_1();
        }
        else {
            const provider = matchValue;
            return singleton(singleton_1((dispatch) => {
                dispatch(new Msg(1, [provider]));
            }));
        }
    })))];
}

export function update(env, filters, msg, model) {
    let tupledArg, tupledArg_1;
    switch (msg.tag) {
        case 1:
            return [new Model(new Remote$1(1, []), new Remote$1(0, [])), (tupledArg = Env_prepareQueryWithTranslations(env, msg.fields[0]), Cmd_loadProducts(tupledArg[0], tupledArg[1]))];
        case 2:
            if (msg.fields[1].tag === 1) {
                return [new Model(new Remote$1(2, [msg.fields[1].fields[0]]), model.SearchedBooks), Cmd_ofEffect((_arg_1) => {
                    Env_fillTranslations(env, msg.fields[1].fields[0].Translations);
                })];
            }
            else {
                return [new Model(new Remote$1(3, [[msg.fields[0], append(msg.fields[1].fields[0][0].Products, singleton_1(Product_notFound))]]), model.SearchedBooks), Cmd_ofEffect((_arg) => {
                    Env_fillTranslations(env, msg.fields[1].fields[0][1]);
                })];
            }
        case 3:
            return [new Model(model.Products, new Remote$1(1, [])), (tupledArg_1 = Env_prepareRequest(env, new CatalogApi_SearchRequest$1(msg.fields[0])), Cmd_searchBooks(tupledArg_1[0], tupledArg_1[1]))];
        case 4:
            if (msg.fields[0].tag === 1) {
                return [new Model(model.Products, new Remote$1(2, [msg.fields[0].fields[0]])), Cmd_none()];
            }
            else {
                return [new Model(model.Products, new Remote$1(3, [PreviewProduct_fromSearchBooksResponse(msg.fields[0].fields[0], filters.Search, Shopfoo_Client_Pages_Shared_Env_IFullContext__IFullContext_get_Translations(env))])), Cmd_none()];
            }
        case 5:
            return [new Model(model.Products, new Remote$1(0, [])), Cmd_none()];
        default:
            return [new Model(new Remote$1(0, []), new Remote$1(0, [])), Cmd_none()];
    }
}

class ProviderProps extends Record {
    constructor(Provider, Text$, Icon, Page) {
        super();
        this.Provider = Provider;
        this.Text = Text$;
        this.Icon = Icon;
        this.Page = Page;
    }
}

function ProviderProps_$reflection() {
    return record_type("Shopfoo.Client.Pages.Product.Index.Page.ProviderProps", [], ProviderProps, () => [["Provider", Provider_$reflection()], ["Text", string_type], ["Icon", class_type("Glutinum.Iconify.IconifyIcon", undefined, IconifyIcon)], ["Page", Page_$reflection()]]);
}

export function ProductIndexView(productIndexViewInputProps) {
    let elems_3;
    const filters = productIndexViewInputProps.filters;
    const env = productIndexViewInputProps.env;
    const matchValue = Env_user(env);
    if ($007CUserCanNotAccess$007C_$007C(new Feat(2, []), matchValue) != null) {
        useEffectOnce(() => {
            Router_navigatePage(Page_CurrentNotFound());
        });
        return defaultOf();
    }
    else {
        let patternInput;
        const init_1 = init(filters);
        patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init_1, (msg, model) => update(env, filters, msg, model), (_arg, _arg_1) => {
        }), undefined, []);
        const model_1 = patternInput[0];
        const dispatch = patternInput[1];
        reactApi.useEffect(() => {
            const matchValue_1 = model_1.Products;
            let matchResult, provider_1;
            if (matchValue_1.tag === 3) {
                if (!equals(Filters__get_Provider(filters), matchValue_1.fields[0][0])) {
                    matchResult = 0;
                    provider_1 = matchValue_1.fields[0][0];
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    dispatch(new Msg(0, []));
                    break;
                }
                case 1: {
                    break;
                }
            }
        });
        let fullContext;
        let copyOfStruct = env;
        fullContext = copyOfStruct.FullContext;
        const translations = Shopfoo_Client_Pages_Shared_Env_IFullContext__IFullContext_get_Translations(env);
        const selectProvider = (provider_2) => {
            dispatch(new Msg(1, [provider_2]));
        };
        const providerCardProps = (provider_3, text, icon, changeFilters) => (new ProviderProps(provider_3, text, icon, new Page(5, [changeFilters(filters)])));
        const providerCardsProps = ofArray([providerCardProps(new Provider(1, []), TranslationPages_Home__get_Books(AppTranslations__get_Home(translations)), book_1, Filters__ToBooks), providerCardProps(new Provider(0, []), TranslationPages_Home__get_Bazaar(AppTranslations__get_Home(translations)), store, Filters__ToBazaar_Z3BF3079)]);
        return createElement("section", createObj(ofArray([["key", "products-page"], (elems_3 = toList(delay(() => {
            let matchValue_3;
            const matchValue_2 = model_1.Products;
            switch (matchValue_2.tag) {
                case 1:
                    return singleton(createElement("div", createObj(Helpers_combineClasses("skeleton", ofArray([["className", "h-32 w-full"], ["key", "products-skeleton"]])))));
                case 2:
                    return singleton(apiError_2("products-load-error", matchValue_2.fields[0], fullContext.User));
                case 3: {
                    const provider_4 = matchValue_2.fields[0][0];
                    const products = matchValue_2.fields[0][1];
                    const allProducts = append((matchValue_3 = model_1.SearchedBooks, (provider_4.tag === 1) ? ((matchValue_3.tag === 3) ? matchValue_3.fields[0].Items : empty_2()) : empty_2()), products);
                    return append_1(singleton(createElement(ProductFilterBar, {
                        key: "products-filter-bar",
                        $key: "products-filter-bar",
                        filters: filters,
                        products: products,
                        selectedProvider: provider_4,
                        selectProvider: selectProvider,
                        searchedBooks: model_1.SearchedBooks,
                        onSearchBooks: (arg) => {
                            dispatch(new Msg(3, [arg]));
                        },
                        onClearSearchedBooks: () => {
                            dispatch(new Msg(5, []));
                        },
                        translations: translations,
                    })), delay(() => singleton(createElement(ProductsTable, {
                        key: "products-table",
                        $key: "products-table",
                        filters: filters,
                        products: allProducts,
                        provider: provider_4,
                        translations: translations,
                    }))));
                }
                default:
                    return map((props_8) => {
                        let elems_2, elems, elems_1;
                        const props = props_8;
                        const key = `card-provider-${toKebab(toText(interpolate("%A%P()", [props.Provider])))}`;
                        return createElement("div", createObj(Helpers_combineClasses("card", ofArray([["className", "card-border"], ["key", key], ["className", "cursor-pointer hover:shadow-lg transition-shadow inline-block min-h-[200px] min-w-[300px] mr-2"], ["onClick", (_arg_2) => {
                            selectProvider(props.Provider);
                            Router_navigatePage(props.Page);
                        }], (elems_2 = [createElement("figure", createObj(ofArray([["key", `${key}-figure`], ["className", "text-8xl text-center p-8"], (elems = [icon_1(props.Icon)], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(Helpers_combineClasses("card-body", ofArray([["key", `${key}-body`], ["className", "items-center text-center"], (elems_1 = [createElement("h2", createObj(Helpers_combineClasses("card-title", ofArray([["key", `${key}-title`], ["children", props.Text]]))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
                    }, sortBy((_arg_5) => _arg_5.Text, providerCardsProps, {
                        Compare: comparePrimitives,
                    }));
            }
        })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
    }
}

